import { render, staticRenderFns } from "./FontSize.vue?vue&type=template&id=e42cd9fe&"
import script from "./FontSize.vue?vue&type=script&lang=ts&"
export * from "./FontSize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports